/**=========================================================
 * Module: app-stat.js
 * Handles stat
 =========================================================*/

App.directive('appStat', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/stat.html',
      restrict: 'E',
      replace: true,
      scope: {
          model: '=model',
          stat: '=stat',
          result: '=result',
          viewstatband: '=viewstatband',
          viewstattype: '=viewstattype',
          viewstatkey: '=viewstatkey',
          setband: '=setband',
          cls: '@cls',
          viewAdditionalSavings: '=viewadditionalsavings',
          currency: '=currency',
          client: '=client'
      }
  };

});
